import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  align-items: center;
`

const CompleteHeader = styled.h2`
  font-family: Montserrat;
  font-size: 40px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #b8e986;
  margin-bottom: 20px;
`

const CompleteMessage = styled.div`
  width: 377px;
  height: 162px;
  font-family: Montserrat;
  font-size: 22px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
`

const Complete = (props) => {
  const { formData } = props

  return (
    <Container className="animated zoomIn">
      <CompleteHeader>You’re all signed up, {formData.name}!</CompleteHeader>
      <CompleteMessage style={{textAlign: 'center'}}>
        <p style={{marginBottom: 20}}>
          A friendly member of our staff will
          reach out to you shortly to confirm
          your arrival.
        </p>
        <p>
          We’re looking forward to
          having you.
        </p>
      </CompleteMessage>
    </Container>
  )
}

export default Complete


// WEBPACK FOOTER //
// ./src/views/Complete.js